import { render, staticRenderFns } from "./SubSequentModal.vue?vue&type=template&id=55af01ab&scoped=true"
import script from "./SubSequentModal.vue?vue&type=script&lang=js"
export * from "./SubSequentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55af01ab",
  null
  
)

export default component.exports